import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { vfmPlugin } from 'vue-final-modal'
import {store} from "@/store";
import vmodal from 'vue-js-modal'
import Cleave from "cleave.js";
import { FocusTrap } from 'focus-trap-vue'


Vue.config.productionTip = false
Vue.use(vfmPlugin)
Vue.use(vmodal, { componentName: 'vmodal', dynamic: true, injectModalsContainer: true })
Vue.component('FocusTrap', FocusTrap)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
